import { callApi } from './api';

import { User, UserRequest } from '@/types/user';

export const updateUser = async (user: UserRequest) => {
  const { status, result } = await callApi<User>(
    'users/user',
    'PUT',
    undefined,
    user,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
